import { createI18n } from 'vue-i18n'
import { en, ar } from './locales'

const i18nConfig = {
  legacy: false,
  locale: import.meta.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: import.meta.env.VUE_APP_I18N_LOCALE,
  messages: {
    en,
    ar,
  },
  pluralRules: {
    ar: (choice: number, choicesLength: number) => {
      if (choice > 5 && choicesLength > 5) {
        return 5
      }

      return choice
    },
  },
}

export const i18n = createI18n(i18nConfig)
